/**
 * Typesense `include_fields` for SRP job search — matches Algolia listing/map hit payloads.
 * Omits large text fields not rendered on hit cards (description, employerOverview, requirements, responsibilities).
 */
export const TYPESENSE_SRP_INCLUDE_FIELDS = [
  'id',
  'objectID',
  'url',
  'score',
  'lastSeen',
  'postedDate',
  'applicationDeadline',
  'isActive',
  'title',
  'normalisedTitle',
  'normalisedRoleLevel',
  'field',
  'specialisations',
  'educationLevel',
  'minimumYearsOfExperience',
  'peopleManagementTier',
  'companyId',
  'companyName',
  'companyIndustry',
  'companyURL',
  'logoUrl',
  'brandColour',
  'heroImage',
  'location',
  'locationList',
  // Map pins label jobs whose point is only a city centre ("no exact address"), see
  // utils/map/is-city-level-job-point.ts.
  'officeLocationPrecision',
  // TEC-482: structured location for hit cards behind dev_enable_new_location_system (gazetteer
  // placeIds + remote scope). regionTags itself isn't needed for display, only for faceting.
  'locationIds',
  'remoteEligibilityScopeType',
  'remoteEligibilityRef',
  // TEC-482 follow-up: plural sibling of remoteEligibilityRef, so a hit card can show every
  // discrete remote country a job lists instead of only the first (see resolveStructuredRemoteScopes).
  'remoteEligibilityRefs',
  // TEC-482 follow-up: carried through to the SRP view model (SrpJobCardViewModel.regionTags) so
  // mobile's server-payload path has the same structured facet value the live Typesense path
  // already sees on the hit, even though the web card itself only uses this for faceting.
  'regionTags',
  'geoloc',
  'remoteness',
  'isFinland',
  'jobType',
  'benefits',
  'skillsAndTechnologies',
  'requiredLanguages',
  'optionalLanguages',
  'salaryRangeMin',
  'salaryRangeMax',
  'salaryPeriod',
  'salaryDetails',
  'currency',
  'salaryIsEstimate',
  'originalSalaryRangeMin',
  'originalSalaryRangeMax',
  'originalSalaryPeriod',
  'originalCurrency',
  'isOpenApplication',
  'isSummerJob',
  'isDriversLicenseRequired',
  'isTyomarkkinatori',
  'isRecruitmentCompany',
  'isConsultingCompany',
  'vacationWeeks',
  // SRP card (HitCardB2): display-only fields, see
  // lambda/indexer.ts (employerGrade) and lambda/utils/computeSalaryBenchmark.ts (the rest).
  'employerGrade',
  'salaryBenchmarkP25',
  'salaryBenchmarkP75',
  'salaryBenchmarkMedian',
  'salaryBenchmarkSampleSize',
  'salaryBenchmarkScope',
  'locale',
  // TEC-717: canonical ATS vendor key for the Quick apply badge (absent until TEC-716's reindex).
  'atsVendor',
].join(',');
